import { ArrowLeft } from "../../../public/Theme";
import Image from "next/image";
import React from "react";
import TypographyPoppins from "@/components/Atoms/TypographyPoppins";

const FilterHeadingWithBackButton = ({
    onBackClick,
    setDrawerOpen,
    filterName,
}) => {
    return (
        <div className="flex items-center gap-x-4 mt-5">
            <Image
                width={0}
                height={0}
                onClick={onBackClick}
                src={ArrowLeft}
                alt={"Black Simple Arrow"}
                className="w-auto h-auto cursor-pointer"
            />
            <TypographyPoppins
                color={"Primary_Default"}
                fontWeight={"normal"}
                text={filterName}
            />
            {/* <Image
                width={0}
                height={0}
                className="w-auto h-auto cursor-pointer"
                onClick={() => {
                    onBackClick();
                    setDrawerOpen(false);
                }}
                src={BlackCross_24x24}
                alt={"Black Cross_ 24x24"}
            /> */}
        </div>
    );
};

export default FilterHeadingWithBackButton;
